/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsemptybody2Inputs */

const en_groupsemptybody2 = /** @type {(inputs: Groupsemptybody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start a group for your regulars or an event and share the invite link. Share an event with tickets and everyone can get them right in the chat.`)
};

const de_groupsemptybody2 = /** @type {(inputs: Groupsemptybody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starte eine Gruppe für deine Stammgäste oder ein Event und teile den Einladungslink. Teilst du ein Event mit Tickets, können alle sie direkt im Chat holen.`)
};

/**
* | output |
* | --- |
* | "Start a group for your regulars or an event and share the invite link. Share an event with tickets and everyone can get them right in the chat." |
*
* @param {Groupsemptybody2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsemptybody2 = /** @type {((inputs?: Groupsemptybody2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsemptybody2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsemptybody2(inputs)
	return de_groupsemptybody2(inputs)
});
export { groupsemptybody2 as "groupsEmptyBody" }